 (function() {
    'use strict';

    const DEBUG = false;
    function log() { if (DEBUG) console.log('[CPC]', ...arguments); }
    function warn() { if (DEBUG) console.warn('[CPC]', ...arguments); }


    // ============================================================
    // CONFIGURATION
    // ============================================================
    const CPC_CONFIG = {
      LOADING_TIMEOUT: 2000,              // Initial page load timeout (ms)
      LOADING_TIMEOUT_COLOR_CHANGE: 2000, // Color variant change timeout (ms)
      LOADING_TIMEOUT_SLIDE_INJECT: 300, // Slide injection timeout (ms)
    };

    // Get data from window object
    const CONFIG = window.CustomPlacementConfig || {};
    const RAW_DATA = CONFIG.rawData;
    const INIT_COLOR = CONFIG.initColor || '';
    const PRODUCT_ID = CONFIG.productId;

    if (!RAW_DATA || typeof RAW_DATA !== 'object') {
      warn('No valid monogram data');
      return;
    }

    // ============================================================
    // DATA NORMALIZATION
    // ============================================================
    const CUSTOM_DATA = {};
    for (const [colorKey, colorValue] of Object.entries(RAW_DATA)) {
      if (!colorValue || typeof colorValue !== 'object') continue;
      const categories = Array.isArray(colorValue.categories) ? colorValue.categories : [];
      CUSTOM_DATA[colorKey.toLowerCase()] = {
        categories: categories.map(cat => ({
          category: cat.category || '',
          styles: Array.isArray(cat.styles) ? cat.styles.map(style => ({
            styleId: style.styleId || Math.random(),
            name: style.name || 'Style',
            category: style.category || '',
            styleType: style.styleType || 'font_style',
            fileGid: style.fileGid || null,
            fileUrl: style.fileUrl || null,
            mimeType: style.mimeType || null,
            swatchUrl: style.swatchUrl || null,
            rules: style.rules || {},
            colors: Array.isArray(style.colors) ? style.colors.map(c => ({
              code: c.code || '',
              name: c.name || ''
            })) : [],
            placements: Array.isArray(style.placements) ? style.placements.map(p => ({
              placementId: p.placementId || Math.random(),
              key: p.key || '',
              label: p.label || '',
              svgUrl: p.svgUrl || null
            })) : []
          })) : []
        })),
        monogramPreviewImage: colorValue.monogramPreviewImage || null
      };
    }

    // ============================================================
    // DOM ELEMENTS - Inline Mode (Dynamic - works with cloned slides)
    // ============================================================
    const formBody = document.querySelector('.cpc-form-body');
    const desktopSlideClone = document.querySelector('#cpc-monogram-slide-desktop');
    const mobileSlideClone = document.querySelector('#cpc-monogram-slide-mobile');

    // Helper functions to get the current active slides
    function getDesktopSlide() {
      let slide = document.querySelector('.info-media-stack-wrapper .cpc-monogram-slide-wrapper .cpc-monogram-slide');
      if (!slide) {
        slide = document.querySelector('.cpc-monogram-slide-wrapper .cpc-desktop-slide');
      }
      if (!slide) {
        slide = document.querySelector('.cpc-desktop-slide');
      }
      return slide;
    }

    function getMobileSlide() {
      let slide = document.querySelector('.swiper-slide.cpc-monogram-slide-wrapper .cpc-mobile-slide');
      if (!slide) {
        slide = document.querySelector('.cpc-monogram-slide-wrapper .cpc-monogram-slide');
      }
      if (!slide) {
        slide = document.querySelector('.cpc-mobile-slide');
      }
      return slide;
    }

    // Helper functions to get elements inside the slides
    function getDesktopImg() {
      const slide = getDesktopSlide();
      return slide ? slide.querySelector('.cpc-desktop-preview-img') : null;
    }

    function getDesktopMonogram() {
      const slide = getDesktopSlide();
      return slide ? slide.querySelector('.cpc-desktop-monogram') : null;
    }

    function getDesktopSvgMonogram() {
      const slide = getDesktopSlide();
      return slide ? slide.querySelector('.cpc-desktop-svg-monogram') : null;
    }

    function getDesktopSvgLeft() {
      const slide = getDesktopSlide();
      return slide ? slide.querySelector('.cpc-desktop-svg-monogram [data-svg-left]') : null;
    }

    function getDesktopSvgCenter() {
      const slide = getDesktopSlide();
      return slide ? slide.querySelector('.cpc-desktop-svg-monogram [data-svg-center]') : null;
    }

    function getDesktopSvgRight() {
      const slide = getDesktopSlide();
      return slide ? slide.querySelector('.cpc-desktop-svg-monogram [data-svg-right]') : null;
    }

    function getDesktopEmptyState() {
      const slide = getDesktopSlide();
      return slide ? slide.querySelector('.cpc-desktop-empty-state') : null;
    }

    function getDesktopEmbroidery() {
      const slide = getDesktopSlide();
      return slide ? slide.querySelector('.cpc-desktop-embroidery') : null;
    }



    function getDesktopImgWrap() {
      const slide = getDesktopSlide();
      return slide ? slide.querySelector('.cpc-preview-img-wrap') : null;
    }

    function getMobileImg() {
      const slide = getMobileSlide();
      return slide ? slide.querySelector('.cpc-mobile-preview-img') : null;
    }

    function getMobileMonogram() {
      const slide = getMobileSlide();
      return slide ? slide.querySelector('.cpc-mobile-monogram') : null;
    }

    function getMobileSvgMonogram() {
      const slide = getMobileSlide();
      return slide ? slide.querySelector('.cpc-mobile-svg-monogram') : null;
    }

    function getMobileSvgLeft() {
      const slide = getMobileSlide();
      return slide ? slide.querySelector('.cpc-mobile-svg-monogram [data-svg-left]') : null;
    }

    function getMobileSvgCenter() {
      const slide = getMobileSlide();
      return slide ? slide.querySelector('.cpc-mobile-svg-monogram [data-svg-center]') : null;
    }

    function getMobileSvgRight() {
      const slide = getMobileSlide();
      return slide ? slide.querySelector('.cpc-mobile-svg-monogram [data-svg-right]') : null;
    }

    function getMobileEmptyState() {
      const slide = getMobileSlide();
      return slide ? slide.querySelector('.cpc-mobile-empty-state') : null;
    }

    function getMobileEmbroidery() {
      const slide = getMobileSlide();
      return slide ? slide.querySelector('.cpc-mobile-embroidery') : null;
    }



    function getMobileImgWrap() {
      const slide = getMobileSlide();
      return slide ? slide.querySelector('.cpc-preview-img-wrap') : null;
    }

    // ============================================================
    // STATE
    // ============================================================
    let state = {
      colorKey: INIT_COLOR || Object.keys(CUSTOM_DATA)[0] || '',
      selectedCategory: null,
      selectedStyle: null,
      selectedColor: null,
      selectedPlacement: null,
      currentText: ''
    };

    let isInitialized = false;
    let desktopSlideInserted = false;
    let mobileSlideInserted = false;

    function getColorData() { return CUSTOM_DATA[state.colorKey] || null; }

    function getCategories() {
      const data = getColorData();
      return data?.categories || [];
    }

    function getStylesForCategory(categoryName) {
      const categories = getCategories();
      const category = categories.find(c => c.category === categoryName);
      return category?.styles || [];
    }

    function getCurrentStyle() {
      if (!state.selectedCategory) return null;
      const styles = getStylesForCategory(state.selectedCategory);
      return styles.find(s => s.styleId === state.selectedStyle) || styles[0] || null;
    }

    function getCurrentPlacement() {
      const style = getCurrentStyle();
      if (!style) return null;
      return style.placements.find(p => p.placementId === state.selectedPlacement) || style.placements[0] || null;
    }

    function getCurrentColor() {
      const style = getCurrentStyle();
      if (!style) return null;
      return style.colors.find(c => c.code === state.selectedColor) || style.colors[0] || null;
    }

    // ============================================================
    // INJECT MONOGRAM SLIDES INTO MEDIA GALLERY
    // ============================================================
    function injectMonogramSlides() {
      // Desktop: Inject into .info-media-stack-wrapper
      const desktopStack = document.querySelector('.stack___pdp-container .info-media-stack-wrapper');
      if (desktopStack && desktopSlideClone && !desktopSlideInserted) {
        const clone = desktopSlideClone.cloneNode(true);
        clone.id = '';
        clone.style.display = '';
        clone.style.width = '100%';
        clone.style.height = '100%';
        
        // Create a wrapper div
        const slideWrapper = document.createElement('div');
        slideWrapper.className = 'pdp-media info-media-image cpc-monogram-slide-wrapper';
        slideWrapper.dataset.media = 'monogram-preview';
        slideWrapper.appendChild(clone);
        
        // Insert as the first slide
        desktopStack.insertBefore(slideWrapper, desktopStack.firstChild);
        desktopSlideInserted = true;
        log('Desktop monogram slide injected');
      }

      // Mobile: Inject into .main-swiper-wrapper .swiper-wrapper
      const mobileSwiperWrapper = document.querySelector('.pdp-media-sm .main-swiper .swiper-wrapper');
      if (mobileSwiperWrapper && mobileSlideClone && !mobileSlideInserted) {
        const clone = mobileSlideClone.cloneNode(true);
        clone.id = '';
        clone.style.display = '';
        clone.style.width = '100%';
        clone.style.height = '100%';
        
        const slideWrapper = document.createElement('div');
        slideWrapper.className = 'swiper-slide cpc-monogram-slide-wrapper';
        slideWrapper.dataset.media = 'monogram-preview';
        slideWrapper.appendChild(clone);
        
        // Insert as the first slide
        mobileSwiperWrapper.insertBefore(slideWrapper, mobileSwiperWrapper.firstChild);
        mobileSlideInserted = true;
        log('Mobile monogram slide injected');
      }

      // Also inject monogramPreviewImage into thumbnails
      injectMonogramThumbnail();
    }

    function injectMonogramThumbnail() {
      const colorData = getColorData();
      const monogramImgSrc = colorData?.monogramPreviewImage?.originalSrc;
      if (!monogramImgSrc) return;

      // Desktop thumbnails (.pdp-media-v)
      const desktopThumbs = document.querySelector('.vertical__medias-wrapper');
      if (desktopThumbs) {
        // Check if already injected
        const existing = desktopThumbs.querySelector('.cpc-monogram-thumb');
        if (!existing) {
          const thumbWrapper = document.createElement('div');
          thumbWrapper.className = 'pdp-media-v info-media-image-v cpc-monogram-thumb';
          thumbWrapper.dataset.media = 'monogram-preview';
          thumbWrapper.innerHTML = `
            <picture class="pinfo-stack-picture-v">
              <source media="(max-width: 600px)" srcset="${monogramImgSrc}">
              <img src="${monogramImgSrc}" alt="Monogram preview" class="vertical__media cpc-monogram-thumb-img" loading="lazy">
            </picture>
          `;
          desktopThumbs.insertBefore(thumbWrapper, desktopThumbs.firstChild);
          log('Desktop monogram thumbnail injected');
        }
      }

      // Mobile thumbnails (.thumb-swiper .swiper-wrapper)
      const mobileThumbs = document.querySelector('.pdp-media-sm .thumb-swiper .swiper-wrapper');
      if (mobileThumbs) {
        // Check if already injected
        const existing = mobileThumbs.querySelector('.cpc-monogram-thumb');
        if (!existing) {
          const thumbWrapper = document.createElement('div');
          thumbWrapper.className = 'swiper-slide thumb-slide cpc-monogram-thumb';
          thumbWrapper.dataset.media = 'monogram-preview';
          thumbWrapper.innerHTML = `
            <div class="pdp-media pdp-media-image thumb-media">
              <img src="${monogramImgSrc}" alt="Monogram preview" class="pdp__thumb-tag cpc-monogram-thumb-img" loading="lazy">
            </div>
          `;
          mobileThumbs.insertBefore(thumbWrapper, mobileThumbs.firstChild);
          log('Mobile monogram thumbnail injected');
        }
      }
    }



    // ============================================================
    // INJECT MONOGRAM SLIDES ON FIRST INTERACTION
    // ============================================================
    let slidesInjected = false;

    function injectMonogramSlidesOnFirstInteraction() {
      if (slidesInjected) return;
      
      // Show loading state, auto-hide after slide injection timeout
      setLoadingState(true, CPC_CONFIG.LOADING_TIMEOUT_SLIDE_INJECT);
      
      // Safety check - make sure we have the clones
      if (!desktopSlideClone || !mobileSlideClone) {
        warn('Slide clones not found');
        setLoadingState(false);
        return;
      }
      
      // Check if slides already exist in DOM (in case of re-render)
      const existingDesktop = document.querySelector('.info-media-stack-wrapper .cpc-monogram-slide-wrapper');
      const existingMobile = document.querySelector('.pdp-media-sm .main-swiper .swiper-wrapper .cpc-monogram-slide-wrapper');
      
      // If slides already exist, just re-initialize and return
      if (existingDesktop && existingMobile) {
        log('Slides already exist, reinitializing only');
        slidesInjected = true;
        
        // Reinitialize Swiper directly
        reinitializeMobileSwiper();
        
        // Force update preview
        setTimeout(function() {
          try {
            updatePreviewImage();
            updateMonogramDisplay();
          } catch (error) {
            warn('Error updating preview:', error);
          }
          // Don't setLoadingState(false) here - it will auto-hide
        }, 100);
        
        return;
      }
      
      // Inject desktop slide
      const desktopStack = document.querySelector('.stack___pdp-container .info-media-stack-wrapper');
      if (desktopStack && desktopSlideClone) {
        // Check if already injected to avoid duplicates
        const existingDesktopCheck = desktopStack.querySelector('.cpc-monogram-slide-wrapper');
        if (!existingDesktopCheck) {
          const clone = desktopSlideClone.cloneNode(true);
          clone.id = '';
          clone.style.display = '';
          clone.style.width = '100%';
          clone.style.height = '100%';
          
          const slideWrapper = document.createElement('div');
          slideWrapper.className = 'pdp-media info-media-image cpc-monogram-slide-wrapper';
          slideWrapper.dataset.media = 'monogram-preview';
          slideWrapper.appendChild(clone);
          
          desktopStack.insertBefore(slideWrapper, desktopStack.firstChild);
          log('Desktop monogram slide injected on first interaction');
        }
      }

      // Inject mobile slide
      const mobileSwiperWrapper = document.querySelector('.pdp-media-sm .main-swiper .swiper-wrapper');
      if (mobileSwiperWrapper && mobileSlideClone) {
        // Check if already injected to avoid duplicates
        const existingMobileCheck = mobileSwiperWrapper.querySelector('.cpc-monogram-slide-wrapper');
        if (!existingMobileCheck) {
          const clone = mobileSlideClone.cloneNode(true);
          clone.id = '';
          clone.style.display = '';
          clone.style.width = '100%';
          clone.style.height = '100%';
          
          const img = clone.querySelector('.cpc-mobile-preview-img');
          if (img) {
            img.style.display = 'block';
          }
          
          const slideWrapper = document.createElement('div');
          slideWrapper.className = 'swiper-slide cpc-monogram-slide-wrapper';
          slideWrapper.dataset.media = 'monogram-preview';
          slideWrapper.appendChild(clone);
          
          mobileSwiperWrapper.insertBefore(slideWrapper, mobileSwiperWrapper.firstChild);
          log('Mobile monogram slide injected on first interaction');
        }
      }

      // Inject thumbnails
      injectMonogramThumbnail();

      slidesInjected = true;
      
      // ============================================================
      // RE-INITIALIZE SWIPER DIRECTLY (NOT through productInfo)
      // ============================================================
      reinitializeMobileSwiper();
      
      // ============================================================
      // RE-INITIALIZE PRODUCT INFORMATION COMPONENTS
      // ============================================================
      const productInfo = document.querySelector('product-information');
      if (productInfo) {
        try {
          if (typeof productInfo.verticalImageChange === 'function') {
            productInfo.verticalImageChange();
            log('verticalImageChange called');
          }
        } catch (error) {
          warn('Error reinitializing product info:', error);
        }
      } else {
        warn('product-information element not found');
      }

      // Force update preview after injection
      // No need to call setLoadingState(false) - it will auto-hide
      setTimeout(function() {
        try {
          updatePreviewImage();
          updateMonogramDisplay();
        } catch (error) {
          warn('Error updating preview:', error);
        }
      }, 150);
    }

    // ============================================================
    // RE-INITIALIZE MOBILE SWIPER (Direct implementation)
    // ============================================================
    function reinitializeMobileSwiper() {
      const container = document.querySelector('.pdp-media-sm');
      if (!container) return;

      const mainSwiperEl = container.querySelector('.main-swiper');
      const thumbSwiperEl = container.querySelector('.thumb-swiper');
      if (!mainSwiperEl || !thumbSwiperEl) return;

      // Get slides count
      const slides = mainSwiperEl.querySelectorAll('.swiper-slide');
      const sliderLength = slides.length;

      // Destroy existing Swiper instances if they exist
      if (mainSwiperEl.swiper) {
        mainSwiperEl.swiper.destroy(true, true);
        log('Main swiper destroyed');
      }
      if (thumbSwiperEl.swiper) {
        thumbSwiperEl.swiper.destroy(true, true);
        log('Thumb swiper destroyed');
      }

      // Re-initialize thumb Swiper
      const thumbSwiper = new Swiper(thumbSwiperEl, {
        slidesPerView: 5,
        spaceBetween: 10,
        watchSlidesProgress: true,
        freeMode: true,
        breakpoints: {
          320: { slidesPerView: 5.5, spaceBetween: 8 },
          640: { slidesPerView: 7, spaceBetween: 10 },
          1024: { slidesPerView: 8, spaceBetween: 12 },
        },
      });

      // Re-initialize main Swiper
      const mobileSwiper = new Swiper(mainSwiperEl, {
        navigation: {
          nextEl: container.querySelector('.swiper-button-prev'),
          prevEl: container.querySelector('.swiper-button-next'),
        },
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        thumbs: {
          swiper: thumbSwiper,
        },
        on: {
          init: function () {
            const totalEl = container.querySelector('.total');
            const currentEl = container.querySelector('.current');
            if (totalEl) totalEl.textContent = this.slides.length;
            if (currentEl) currentEl.textContent = this.realIndex + 1;

            if (sliderLength < 7) {
              const paginationEl = container.querySelector('.swiper-pagination');
              if (paginationEl) {
                paginationEl.classList.add('justify-center');
              }
            }
          },
          slideChange: function () {
            const currentEl = container.querySelector('.current');
            if (currentEl) currentEl.textContent = this.realIndex + 1;
          },
        },
      });

      // Store references
      mainSwiperEl.swiper = mobileSwiper;
      thumbSwiperEl.swiper = thumbSwiper;

      log('Mobile Swiper reinitialized directly');
    }

    // ============================================================
    // FIX DESKTOP VERTICAL GALLERY
    // ============================================================
    function fixDesktopVerticalGallery() {
      const desktopThumbs = document.querySelector('.vertical__medias-wrapper');
      if (!desktopThumbs) return;

      const verticalImages = desktopThumbs.querySelectorAll('.pdp-media-v');
      const galleryImages = document.querySelectorAll('.info-media-stack-wrapper .pdp-media');

      // Remove all existing click listeners by cloning and replacing
      verticalImages.forEach((verticalImage) => {
        const newVerticalImage = verticalImage.cloneNode(true);
        verticalImage.parentNode.replaceChild(newVerticalImage, verticalImage);
      });

      // Re-query the vertical images after replacement
      const newVerticalImages = desktopThumbs.querySelectorAll('.pdp-media-v');
      
      // Remove active from all
      newVerticalImages.forEach((img) => {
        img.classList.remove('active');
      });
      
      // Set first as active (monogram thumb should be first)
      if (newVerticalImages.length > 0) {
        newVerticalImages[0].classList.add('active');
        log('First vertical thumb set as active');
      }

      // Add click handlers
      newVerticalImages.forEach((verticalImage) => {
        verticalImage.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Remove active from all
          newVerticalImages.forEach((img) => {
            img.classList.remove('active');
          });
          
          // Add active to clicked
          this.classList.add('active');

          const mediaId = this.dataset.media;
          
          // Find matching gallery image
          const matchedGalleryImage = Array.from(galleryImages).find(
            (galleryImage) => galleryImage.dataset.media === mediaId
          );

          if (matchedGalleryImage) {
            const parent = matchedGalleryImage.parentNode;
            parent.prepend(matchedGalleryImage);
          }
        });
      });

      log('Desktop vertical gallery fixed');
    }


    // ============================================================
    // ACTIVATE MONOGRAM PREVIEW ON INTERACTION
    // ============================================================
    function activateMonogramPreview() {
      // ---- DESKTOP ----
      // 1. Activate the monogram thumbnail
      const desktopThumbs = document.querySelector('.vertical__medias-wrapper');
      if (desktopThumbs) {
        // Remove active from all thumbnails
        desktopThumbs.querySelectorAll('.pdp-media-v').forEach(el => {
          el.classList.remove('active');
        });
        
        // Add active to monogram thumb
        const monogramThumb = desktopThumbs.querySelector('.cpc-monogram-thumb');
        if (monogramThumb) {
          monogramThumb.classList.add('active');
          log('Desktop monogram thumb activated');
        }
      }
      
      // 2. Move monogram slide to top in desktop gallery
      const desktopStack = document.querySelector('.info-media-stack-wrapper');
      if (desktopStack) {
        const monogramSlide = desktopStack.querySelector('.cpc-monogram-slide-wrapper');
        if (monogramSlide) {
          if (monogramSlide !== desktopStack.firstChild) {
            desktopStack.insertBefore(monogramSlide, desktopStack.firstChild);
            log('Desktop monogram slide moved to top');
          }
        }
      }

      // ---- MOBILE ----
      // DO NOT reinitialize Swiper here - it's already done in injectMonogramSlidesOnFirstInteraction()
      // Just get the current Swiper instances and slide to the correct index
      
      const mainSwiperEl = document.querySelector('.pdp-media-sm .main-swiper');
      const thumbSwiperEl = document.querySelector('.pdp-media-sm .thumb-swiper');
      
      if (!mainSwiperEl || !mainSwiperEl.swiper) {
        log('Mobile swiper not found');
        return;
      }

      // Find and slide to monogram slide in main swiper
      const slides = mainSwiperEl.querySelectorAll('.swiper-slide');
      let monogramIndex = -1;
      slides.forEach((slide, index) => {
        if (slide.classList.contains('cpc-monogram-slide-wrapper')) {
          monogramIndex = index;
        }
      });
      
      if (monogramIndex !== -1 && monogramIndex !== mainSwiperEl.swiper.activeIndex) {
        mainSwiperEl.swiper.slideTo(monogramIndex, 300);
        log('Mobile swiper slid to monogram slide at index:', monogramIndex);
      } else if (monogramIndex !== -1) {
        log('Monogram slide is already active');
      }

      // ---- MOBILE THUMBS ----
      if (thumbSwiperEl && thumbSwiperEl.swiper) {
        const thumbSlides = thumbSwiperEl.querySelectorAll('.swiper-slide');
        let monogramThumbIndex = -1;
        thumbSlides.forEach((slide, index) => {
          if (slide.classList.contains('cpc-monogram-thumb')) {
            monogramThumbIndex = index;
          }
        });
        
        if (monogramThumbIndex !== -1 && monogramThumbIndex !== thumbSwiperEl.swiper.activeIndex) {
          thumbSwiperEl.swiper.slideTo(monogramThumbIndex, 300);
          log('Mobile thumb swiper slid to monogram thumb at index:', monogramThumbIndex);
        }
      }
    }

    // ============================================================
    // FONT LOADING
    // ============================================================
    const loadedFonts = new Set();

    function ensureFontFace(style) {
      if (style.styleType !== 'font_style' || !style.fileUrl) return;
      const tag = `cpc-font-${style.styleId}`;
      if (loadedFonts.has(tag) || document.querySelector(`style[data-cpc-font="${tag}"]`)) return;
      const format = style.mimeType === 'font/ttf' ? 'truetype' :
        style.mimeType === 'font/otf' ? 'opentype' :
        style.mimeType === 'font/woff2' ? 'woff2' : 'woff';
      const styleEl = document.createElement('style');
      styleEl.setAttribute('data-cpc-font', tag);
      styleEl.textContent = `@font-face { font-family: '${tag}'; src: url('${style.fileUrl}') format('${format}'); font-display: swap; }`;
      document.head.appendChild(styleEl);
      loadedFonts.add(tag);
      log('Loaded font:', style.name);
    }

    // ============================================================
    // SVG MONOGRAM HELPERS
    // ============================================================
    function clearSvgDisplay(isMobileView) {
      const svgLeft = isMobileView ? getMobileSvgLeft() : getDesktopSvgLeft();
      const svgCenter = isMobileView ? getMobileSvgCenter() : getDesktopSvgCenter();
      const svgRight = isMobileView ? getMobileSvgRight() : getDesktopSvgRight();
      const svgContainer = isMobileView ? getMobileSvgMonogram() : getDesktopSvgMonogram();
      
      [svgLeft, svgCenter, svgRight].forEach(el => { if (el) el.innerHTML = ''; });
      if (svgContainer) svgContainer.style.display = 'none';
    }

    function clearTextDisplay(isMobileView) {
      const textMonogram = isMobileView ? getMobileMonogram() : getDesktopMonogram();
      if (textMonogram) textMonogram.textContent = '';
    }

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function shouldUseSvgForMonogram(style) {
      if (!style) return false;
      if (style.styleType === 'block_style') return true;
      const fontName = style.name.toLowerCase();
      return window.MONOGRAM_SVGS && window.MONOGRAM_SVGS[fontName];
    }

    function getSvgFromVariable(fontName, letter, position) {
      const font = fontName.toLowerCase().trim();
      const upper = letter.toUpperCase();
      return window.MONOGRAM_SVGS?.[font]?.[upper]?.[position] || null;
    }

    function getLetterWidth(fontName, letter, position) {
      const font = fontName.toLowerCase().trim();
      const upper = letter.toUpperCase();
      return window.MONOGRAM_LAYOUT?.[font]?.[upper]?.[position] || null;
    }

    // ============================================================
    // MONOGRAM RENDERING
    // ============================================================
    async function updateSvgMonogram(text, style, color, isMobileView) {
      if (!text || text.length === 0) return false;

      const raw = text.toUpperCase().replace(/[^A-Z]/g, '');

      let slots = { left: '', center: '', right: '' };
      if (raw.length === 1) { slots.center = raw[0]; } 
      else if (raw.length === 2) { slots.left = raw[0]; slots.right = raw[1]; } 
      else if (raw.length >= 3) { slots.left = raw[0]; slots.center = raw[1]; slots.right = raw[2]; }

      const svgLeft = isMobileView ? getMobileSvgLeft() : getDesktopSvgLeft();
      const svgCenter = isMobileView ? getMobileSvgCenter() : getDesktopSvgCenter();
      const svgRight = isMobileView ? getMobileSvgRight() : getDesktopSvgRight();
      const svgContainer = isMobileView ? getMobileSvgMonogram() : getDesktopSvgMonogram();

      const positions = [
        { pos: 'left', container: svgLeft },
        { pos: 'center', container: svgCenter },
        { pos: 'right', container: svgRight },
      ];

      let hasAllSymbols = true;
      let hasAnyLetter = false;

      if (svgContainer) {
        svgContainer.style.top = '50%';
        svgContainer.style.left = '50%';
        svgContainer.style.transform = 'translate(-50%, -50%)';
      }

      const fontName = style.name;

      for (const { pos: positionName, container } of positions) {
        if (!container) continue;
        const letter = slots[positionName];

        if (letter) {
          hasAnyLetter = true;
          const svgString = getSvgFromVariable(fontName, letter, positionName);
          if (svgString) {
            if (container.innerHTML !== svgString) container.innerHTML = svgString;
            const letterWidth = getLetterWidth(fontName, letter, positionName);
            if (letterWidth) {
              container.style.width = `${letterWidth}%`;
              container.style.flex = `0 0 ${letterWidth}%`;
            } else {
              container.style.width = 'auto';
              container.style.flex = '0 0 auto';
            }
            container.style.display = 'inline-flex';
            container.style.alignItems = 'center';
            container.style.justifyContent = 'center';
            const svgEl = container.querySelector('svg');
            if (svgEl) svgEl.style.color = color;
          } else {
            hasAllSymbols = false;
            container.innerHTML = '';
            container.style.display = 'none';
          }
        } else {
          container.innerHTML = '';
          container.style.display = 'none';
        }
      }

      if (svgContainer) svgContainer.style.display = hasAnyLetter ? 'block' : 'none';
      return hasAllSymbols && hasAnyLetter;
    }


    function updateTextMonogram(text, style, color, isMobileView) {
      clearSvgDisplay(isMobileView);

      const fontTag = (style && style.styleType === 'font_style') ? `cpc-font-${style.styleId}` : 'inherit';
      const target = isMobileView ? getMobileMonogram() : getDesktopMonogram();

      let displayText = text || '';
      const rules = style?.rules || {};
      
      if (rules.inputType === 'date' && text) {
        const digits = text.replace(/[^0-9]/g, '');
        if (digits.length > 0) {
          let formatted = digits;
          if (digits.length > 2) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2);
          }
          if (digits.length > 4) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
          }
          displayText = formatted;
        } else {
          displayText = '';
        }
      }

      if (target) {
        target.textContent = displayText;
        target.style.color = color || '#000';
        target.style.fontFamily = `'${fontTag}'`;
        target.style.fontSize = '24px';
        target.style.top = '50%';
        target.style.left = '50%';
        target.style.transform = 'translate(-50%, -50%)';
        target.style.display = text ? 'block' : 'none';
      }

      const svgContainer = isMobileView ? getMobileSvgMonogram() : getDesktopSvgMonogram();
      if (svgContainer) svgContainer.style.display = 'none';
    }

    // ============================================================
    // EMBROIDERY RENDERING ENGINE
    // ============================================================
    function hexToRgb(hex) {
      hex = hex.trim();
      if (hex[0] !== '#') {
        const d = document.createElement('div');
        d.style.color = hex;
        document.body.appendChild(d);
        const computed = getComputedStyle(d).color;
        document.body.removeChild(d);
        const m = computed.match(/\d+/g);
        return { r: +m[0], g: +m[1], b: +m[2] };
      }
      let h = hex.replace('#', '');
      if (h.length === 3) h = h.split('').map(c => c + c).join('');
      const num = parseInt(h, 16);
      return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
    }

    function shadeRGB(rgb, amt) {
      const f = (c) => {
        let v = amt > 0 ? c + (255 - c) * amt : c + c * amt;
        return Math.max(0, Math.min(255, Math.round(v)));
      };
      return { r: f(rgb.r), g: f(rgb.g), b: f(rgb.b) };
    }

    function shade(rgb, amt) {
      const s = shadeRGB(rgb, amt);
      return `rgb(${s.r}, ${s.g}, ${s.b})`;
    }

    function rgba(rgb, a) {
      return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${a})`;
    }

    function makeRng(seed) {
      let s = seed % 2147483647;
      if (s <= 0) s += 2147483646;
      return function() {
        s = (s * 16807) % 2147483647;
        return (s - 1) / 2147483646;
      };
    }

    function fontWeightFor(fontFamily) {
      return /script|cursive/i.test(fontFamily) ? '600' : '700';
    }

    function fitFontSize(text, fontFamily, canvasWidth, canvasHeight) {
      const off = document.createElement('canvas');
      off.width = canvasWidth;
      off.height = canvasHeight;
      const offCtx = off.getContext('2d');
      
      const weight = fontWeightFor(fontFamily);
      const maxW = canvasWidth * 0.86;
      const maxH = canvasHeight * 0.5;
      let lo = 10, hi = 160, best = 40;
      offCtx.save();
      while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        offCtx.font = `${weight} ${mid}px ${fontFamily}`;
        const m = offCtx.measureText(text || ' ');
        const w = m.width;
        const h = (m.actualBoundingBoxAscent || mid * 0.8) + (m.actualBoundingBoxDescent || mid * 0.2);
        if (w <= maxW && h <= maxH) {
          best = mid;
          lo = mid + 1;
        } else {
          hi = mid - 1;
        }
      }
      offCtx.restore();
      return best;
    }

    function getTextMask(text, fontFamily, fontSize, canvasWidth, canvasHeight) {
      const off = document.createElement('canvas');
      off.width = canvasWidth;
      off.height = canvasHeight;
      const offCtx = off.getContext('2d');
      
      const weight = fontWeightFor(fontFamily);
      offCtx.clearRect(0, 0, canvasWidth, canvasHeight);
      offCtx.fillStyle = '#000';
      offCtx.font = `${weight} ${fontSize}px ${fontFamily}`;
      offCtx.textAlign = 'center';
      offCtx.textBaseline = 'alphabetic';
      const cx = canvasWidth / 2;
      const cy = canvasHeight / 2 + fontSize * 0.32;
      offCtx.fillText(text, cx, cy);
      const imgData = offCtx.getImageData(0, 0, canvasWidth, canvasHeight);
      return { data: imgData.data, baselineY: cy, cx: cx };
    }

    function isFilled(maskData, x, y, canvasWidth, canvasHeight) {
      if (x < 0 || x >= canvasWidth || y < 0 || y >= canvasHeight) return false;
      const idx = (y * canvasWidth + x) * 4 + 3;
      return maskData[idx] > 80;
    }

    function getColumnRuns(maskData, canvasWidth, canvasHeight) {
      const runs = [];
      for (let x = 0; x < canvasWidth; x++) {
        const colRuns = [];
        let inRun = false, top = 0;
        for (let y = 0; y < canvasHeight; y++) {
          const f = isFilled(maskData, x, y, canvasWidth, canvasHeight);
          if (f && !inRun) { inRun = true; top = y; }
          if (!f && inRun) { inRun = false; colRuns.push([top, y - 1]); }
        }
        if (inRun) colRuns.push([top, canvasHeight - 1]);
        runs.push(colRuns);
      }
      return runs;
    }

    function columnFilledAt(runs, x, y) {
      if (x < 0 || x >= runs.length) return false;
      const colRuns = runs[x];
      for (let i = 0; i < colRuns.length; i++) {
        if (y >= colRuns[i][0] && y <= colRuns[i][1]) return true;
      }
      return false;
    }

    function drawSatinFill(ctx, runs, spacing, lineWidth, passes, color, rng, opts, canvasWidth, canvasHeight) {
      opts = opts || {};
      ctx.lineCap = 'round';
      ctx.strokeStyle = color;
      ctx.lineWidth = lineWidth;

      const step = Math.max(1, Math.round(spacing));
      for (let y = 0; y < canvasHeight; y += step) {
        let x = 0;
        while (x < canvasWidth) {
          if (columnFilledAt(runs, x, y)) {
            let xStart = x;
            while (x < canvasWidth && columnFilledAt(runs, x, y)) x++;
            let xEnd = x;
            const midY = y + (opts.flat ? 0 : (rng() - 0.5) * spacing * 0.5);
            ctx.beginPath();
            ctx.moveTo(xStart, midY - 0.6);
            ctx.lineTo(xEnd, midY + 0.6);
            ctx.stroke();
          } else {
            x++;
          }
        }
      }
    }

    function drawStitchDashes(ctx, runs, spacing, threadW, rgb, rng, canvasWidth, canvasHeight) {
      const dashColorDark = shade(rgb, -0.22);
      const dashColorLight = shade(rgb, 0.18);
      const step = Math.max(2, Math.round(spacing));

      ctx.lineCap = 'round';

      for (let x = 0; x < canvasWidth; x += step) {
        const colRuns = runs[x];
        for (let r = 0; r < colRuns.length; r++) {
          const top = colRuns[r][0], bottom = colRuns[r][1];
          if (bottom - top < 1) continue;
          const segH = Math.max(3, spacing * 1.4);
          for (let y = top; y <= bottom; y += segH) {
            const yEnd = Math.min(bottom, y + segH * 0.92);
            const slant = (rng() - 0.5) * 2.0;
            const alt = rng();
            ctx.strokeStyle = alt > 0.5 ? dashColorDark : dashColorLight;
            ctx.globalAlpha = 0.55 + alt * 0.25;
            ctx.lineWidth = Math.max(0.6, threadW * 0.22);
            ctx.beginPath();
            ctx.moveTo(x - threadW * 0.3 + slant, y);
            ctx.lineTo(x + threadW * 0.3 - slant, yEnd);
            ctx.stroke();
          }
        }
      }
      ctx.globalAlpha = 1;
    }

    function drawHighlightSheen(ctx, runs, spacing, threadW, rgb, rng, canvasWidth, canvasHeight) {
      const highlightRGB = shadeRGB(rgb, 0.62);
      const superHighlightRGB = shadeRGB(rgb, 0.85);

      ctx.lineCap = 'round';

      const step = Math.max(1, Math.round(spacing));
      for (let x = 0; x < canvasWidth; x += step) {
        const colRuns = runs[x];
        for (let r = 0; r < colRuns.length; r++) {
          const top = colRuns[r][0], bottom = colRuns[r][1];
          const runHeight = bottom - top;
          if (runHeight < 1) continue;
          const bandTop = top;
          const bandBottom = top + Math.max(1, runHeight * 0.32);

          const grad = ctx.createLinearGradient(x, bandTop, x, bandBottom + (bandBottom - bandTop));
          grad.addColorStop(0, rgba(superHighlightRGB, 0.85));
          grad.addColorStop(0.45, rgba(highlightRGB, 0.45));
          grad.addColorStop(1, rgba(rgb, 0));

          ctx.strokeStyle = grad;
          ctx.lineWidth = Math.max(1, threadW * 0.55);
          ctx.beginPath();
          ctx.moveTo(x, bandTop);
          ctx.lineTo(x, bandBottom);
          ctx.stroke();

          if (rng() > 0.86) {
            ctx.fillStyle = rgba(superHighlightRGB, 0.9);
            ctx.beginPath();
            ctx.arc(x + (rng() - 0.5) * 1.5, bandTop + (bandBottom - bandTop) * 0.3, threadW * 0.18, 0, Math.PI * 2);
            ctx.fill();
          }
        }
      }
    }

    function renderEmbroideryOnCanvas(canvas, text, color, fontFamily, isMobileView) {
      if (!canvas || !text || !text.trim()) {
        if (canvas) canvas.classList.remove('active');
        return;
      }

      const ctx = canvas.getContext('2d');
      const W = canvas.width;
      const H = canvas.height;

      ctx.clearRect(0, 0, W, H);

      let displayText = text;
      const style = getCurrentStyle();
      if (style && style.rules && style.rules.inputType === 'date') {
        const digits = text.replace(/[^0-9]/g, '');
        if (digits.length > 0) {
          let formatted = digits;
          if (digits.length > 2) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2);
          }
          if (digits.length > 4) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
          }
          displayText = formatted;
        }
      }

      const rgb = hexToRgb(color);
      const isWhiteish = (rgb.r > 240 && rgb.g > 240 && rgb.b > 240);

      const thickness = 2;
      const density = 6;
      const showStitches = true;
      const showHighlight = false;
      const showShadow = false;

      const fontSize = fitFontSize(displayText, fontFamily, W, H);
      const mask = getTextMask(displayText, fontFamily, fontSize, W, H);
      const runs = getColumnRuns(mask.data, W, H);

      const spacing = Math.max(2, 9 - density * 1.3);
      const threadW = 1.2 + thickness * 1.5;
      const numLayers = Math.min(5, Math.max(2, Math.round(thickness * 1.1) + 1));

      const rng = makeRng(hashStr(displayText + fontFamily + color));

      if (showShadow) {
        ctx.save();
        ctx.translate(2.5, 4);
        ctx.globalAlpha = 0.32;
        drawSatinFill(ctx, runs, spacing, threadW, numLayers, '#000000', rng, { flat: true }, W, H);
        ctx.restore();
      }

      for (let layer = 0; layer < numLayers; layer++) {
        const t = numLayers <= 1 ? 0 : layer / (numLayers - 1);
        const layerShade = -0.38 + t * 0.5;
        const jitter = (numLayers - layer) * 0.35;
        ctx.save();
        ctx.translate(
          (rng() - 0.5) * jitter * 0.6,
          (rng() - 0.5) * jitter * 0.6
        );
        const layerColor = shade(rgb, layerShade);
        const lw = threadW * (1 - layer * 0.08);
        drawSatinFill(ctx, runs, spacing, lw, 1, layerColor, rng, {}, W, H);
        ctx.restore();
      }

      if (showStitches) {
        drawStitchDashes(ctx, runs, spacing, threadW, rgb, rng, W, H);
      }

      if (showHighlight) {
        drawHighlightSheen(ctx, runs, spacing, threadW, rgb, rng, W, H);
      }

      if (isWhiteish) {
        ctx.save();
        ctx.globalAlpha = 0.5;
        ctx.strokeStyle = 'rgba(0,0,0,0.18)';
        ctx.lineWidth = 1;
        for (let x = 0; x < W; x++) {
          const colRuns = runs[x];
          for (let r = 0; r < colRuns.length; r++) {
            ctx.beginPath();
            ctx.moveTo(x, colRuns[r][0]);
            ctx.lineTo(x, colRuns[r][1]);
            ctx.stroke();
          }
        }
        ctx.restore();
      }

      canvas.classList.add('active');
    }



    function hashStr(s) {
      let h = 0;
      for (let i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) | 0; }
      return Math.abs(h) || 1;
    }



    // ============================================================
    // INPUT TYPE COMPATIBILITY HELPERS
    // ============================================================
    function getInputTypeCategory(rules) {
      // If rules is empty or undefined, treat as 'text'
      if (!rules || Object.keys(rules).length === 0) {
        return 'text';
      }
      const inputType = rules?.inputType || 'text';
      if (inputType === 'alphanumeric') return 'alphanumeric';
      if (inputType === 'letters') return 'letters';
      if (inputType === 'numbers') return 'numbers';
      if (inputType === 'date') return 'date';
      return 'text';
    }

    function isInputCompatible(newRules, currentText) {
      const newType = getInputTypeCategory(newRules);
      
      // If no text, always compatible (nothing to clear)
      if (!currentText || currentText.length === 0) {
        return true;
      }
      
      // Check if current text is valid for the new type
      if (newType === 'numbers') {
        return /^[0-9]*$/.test(currentText);
      }
      if (newType === 'letters') {
        return /^[a-zA-Z]*$/.test(currentText);
      }
      if (newType === 'alphanumeric') {
        return /^[a-zA-Z0-9]*$/.test(currentText);
      }
      if (newType === 'date') {
        return /^[0-9]*$/.test(currentText);
      }
      // For 'text' type, everything is compatible
      return true;
    }



  // ============================================================
  // TOOLTIP NOTIFICATION - DYNAMIC DOM
  // ============================================================
  var tooltipElement = null;
  var tooltipTimeout = null;

  function createTooltip(message) {
    removeTooltip();
    var tooltip = document.createElement('div');
    tooltip.className = 'cpc-tooltip-notification';
    tooltip.id = 'cpc-tooltip-notification';
    tooltip.innerHTML = '<span class="cpc-tooltip-icon">⚠️</span><span class="cpc-tooltip-text">' + (message || 'Please select a category first') + '</span>';
    document.body.appendChild(tooltip);
    tooltipElement = tooltip;
    requestAnimationFrame(function() {
      tooltip.classList.add('show');
    });
    return tooltip;
  }

  function showTooltip(message, duration) {
    duration = duration || 3000;
    removeTooltip();
    var tooltip = createTooltip(message);
    if (tooltipTimeout) {
      clearTimeout(tooltipTimeout);
      tooltipTimeout = null;
    }
    
    // Scroll to category section
    scrollToCategorySection();
    
    tooltipTimeout = setTimeout(function() {
      hideTooltip();
    }, duration);
  }

  function scrollToCategorySection() {
    // Find the category section
    var categorySection = document.querySelector('.cpc-section');
    if (!categorySection) {
      categorySection = document.querySelector('.cpc-form-body');
      if (!categorySection) {
        categorySection = document.querySelector('.cpc-placement-wrapper');
      }
    }
    
    if (categorySection) {
      var rect = categorySection.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var windowHeight = window.innerHeight;
      var elementHeight = rect.height;
      
      // Calculate position to center the element in the viewport
      // Target: element top should be at (windowHeight - elementHeight) / 2
      var targetPosition = rect.top + scrollTop - ((windowHeight - elementHeight) / 2);
      
      // If element is taller than viewport, just scroll to its top with some offset
      if (elementHeight > windowHeight) {
        targetPosition = rect.top + scrollTop - 80;
      }
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }

  function hideTooltip() {
    if (tooltipElement) {
      tooltipElement.classList.remove('show');
      var onTransitionEnd = function() {
        removeTooltip();
        tooltipElement.removeEventListener('transitionend', onTransitionEnd);
      };
      tooltipElement.addEventListener('transitionend', onTransitionEnd);
      setTimeout(function() {
        if (tooltipElement) {
          removeTooltip();
        }
      }, 500);
    }
    if (tooltipTimeout) {
      clearTimeout(tooltipTimeout);
      tooltipTimeout = null;
    }
  }

  function removeTooltip() {
    if (tooltipElement && tooltipElement.parentNode) {
      tooltipElement.parentNode.removeChild(tooltipElement);
    }
    tooltipElement = null;
  }



    // ============================================================
    // LOADING STATE MANAGEMENT
    // ============================================================
    let isLoading = false;
    let loadingQueue = [];

    function setLoadingState(loading, duration) {
      const wrapper = document.querySelector('.cpc-placement-wrapper.cpc-placement-block-wrapper');
      if (!wrapper) return;
      
      // Clear any existing timeout
      if (wrapper._loadingTimeout) {
        clearTimeout(wrapper._loadingTimeout);
        wrapper._loadingTimeout = null;
      }
      
      isLoading = loading;
      
      if (loading) {
        wrapper.classList.add('loading');
        
        // If duration is provided, auto-hide after that time
        if (duration && duration > 0) {
          wrapper._loadingTimeout = setTimeout(function() {
            setLoadingState(false);
          }, duration);
        }
      } else {
        wrapper.classList.remove('loading');
        processLoadingQueue();
      }
    }

    function queueAction(action) {
      loadingQueue.push(action);
    }

    function processLoadingQueue() {
      while (loadingQueue.length > 0) {
        const action = loadingQueue.shift();
        if (typeof action === 'function') {
          action();
        }
      }
    }

    function isReady() {
      return !isLoading;
    }

    function waitForReady(action) {
      if (isReady()) {
        action();
      } else {
        queueAction(action);
      }
    }

    // ============================================================
    // UPDATE MONOGRAM DISPLAY
    // ============================================================
    async function updateMonogramDisplay() {
      const style = getCurrentStyle();
      const colorObj = getCurrentColor();
      const text = state.currentText || '';
      const isMobileView = isMobile();

      if (!style) return;

      const imgWrap = isMobileView ? getMobileImgWrap() : getDesktopImgWrap();
      const emptyState = isMobileView ? getMobileEmptyState() : getDesktopEmptyState();
      const fontCanvas = isMobileView ? getMobileEmbroidery() : getDesktopEmbroidery();
      const color = colorObj?.code || '#000';

      // Update preview image
      updatePreviewImage();

      // Show/hide empty state
      if (emptyState) {
        if (text.length === 0) {
          emptyState.classList.add('visible');
        } else {
          emptyState.classList.remove('visible');
        }
      }

      // Hide monogram elements when no text
      if (text.length === 0) {
        if (imgWrap) imgWrap.classList.remove('has-svg');
        clearSvgDisplay(isMobileView);
        clearTextDisplay(isMobileView);
        if (fontCanvas) fontCanvas.classList.remove('active');
        return;
      }

      // For block_style (Circle, Diamond) - show SVG directly, NO canvas
      if (style.styleType === 'block_style') {
        // Hide canvas if visible
        if (fontCanvas) fontCanvas.classList.remove('active');
        clearTextDisplay(isMobileView);
        
        // Generate and show SVG directly
        const svgSuccess = await updateSvgMonogram(text, style, color, isMobileView);
        if (svgSuccess && imgWrap) {
          imgWrap.classList.add('has-svg');
        } else {
          if (imgWrap) imgWrap.classList.remove('has-svg');
          // Fallback to text if SVG fails
          updateTextMonogram(text, style, color, isMobileView);
        }
        return;
      }

      // For font_style - use embroidery canvas directly (NO SVG)
      // Check if SVG exists in MONOGRAM_SVGS for this font
      if (shouldUseSvgForMonogram(style)) {
        // If SVG exists, use it directly (not canvas)
        if (fontCanvas) fontCanvas.classList.remove('active');
        
        const svgSuccess = await updateSvgMonogram(text, style, color, isMobileView);
        if (svgSuccess && imgWrap) {
          imgWrap.classList.add('has-svg');
        } else {
          if (imgWrap) imgWrap.classList.remove('has-svg');
          updateTextMonogram(text, style, color, isMobileView);
        }
      } else {
        // No SVG available - use embroidery canvas for text
        if (imgWrap) imgWrap.classList.remove('has-svg');
        clearSvgDisplay(isMobileView);
        clearTextDisplay(isMobileView);
        
        let fontFamily = style.name || 'Arial';
        if (style.fileUrl) {
          fontFamily = `'cpc-font-${style.styleId}'`;
        }
        
        renderEmbroideryOnCanvas(fontCanvas, text, color, fontFamily, isMobileView);
      }
    }

    // ============================================================
    // PREVIEW IMAGE
    // ============================================================
    function updatePreviewImage() {
      const colorData = getColorData();
      let src = null, alt = '';

      if (colorData?.monogramPreviewImage?.originalSrc) {
        src = colorData.monogramPreviewImage.originalSrc;
        alt = colorData.monogramPreviewImage.altText || '';
      }

      // Update desktop image
      const desktopImg = document.querySelector('.cpc-desktop-slide .cpc-desktop-preview-img') || getDesktopImg();
      if (desktopImg) {
        desktopImg.src = src || '';
        desktopImg.alt = alt;
        desktopImg.style.display = src ? 'block' : 'none';
      }
      
      // Update mobile image
      const mobileImg = document.querySelector('.cpc-mobile-slide .cpc-mobile-preview-img') || getMobileImg();
      if (mobileImg) {
        mobileImg.src = src || '';
        mobileImg.alt = alt;
        mobileImg.style.display = src ? 'block' : 'none';
      }
    }

    // ============================================================
    // VALIDATION
    // ============================================================
    function isCurrentSelectionValid() {
      const style = getCurrentStyle();
      if (!style) return false;

      const rules = style.rules || {};
      const inputType = rules.inputType || 'text';
      const text = state.currentText || '';
      const textLen = text.length;

      if (textLen === 0) return false;
      
      if (inputType === 'date') {
        const digits = text.replace(/[^0-9]/g, '');
        return digits.length === 6;
      }
      
      if (inputType === 'letters' && !/^[a-zA-Z]*$/.test(text)) return false;
      if (inputType === 'numbers' && !/^[0-9]*$/.test(text)) return false;
      if (inputType === 'alphanumeric' && !/^[a-zA-Z0-9]*$/.test(text)) return false;
      
      const minLen = rules.minLength || 0;
      const maxLen = rules.maxLength || 999;
      if (minLen > 0 && textLen < minLen) return false;
      if (maxLen < 999 && textLen > maxLen) return false;

      return true;
    }

    function getValidationMessage(style, text) {
      if (!style) return '';
      
      const rules = style.rules || {};
      const inputType = rules.inputType || 'text';
      const minLen = rules.minLength || 0;
      const maxLen = rules.maxLength || 999;
      const textLen = text.length;
      const digits = text.replace(/[^0-9]/g, '');
      
      if (textLen === 0) return '';
      
      if (inputType === 'date') {
        if (digits.length > 0 && digits.length < 6) {
          return `Please enter 6 digits (DDMMYY). Currently ${digits.length}/6 digits entered.`;
        }
        if (digits.length === 6) return '';
        if (text !== digits) return 'Only numbers (0-9) are allowed for date format.';
        return '';
      }
      
      if (inputType === 'letters' && !/^[a-zA-Z]*$/.test(text)) {
        return 'Only letters (A-Z) are allowed for this style.';
      }
      if (inputType === 'numbers' && !/^[0-9]*$/.test(text)) {
        return 'Only numbers (0-9) are allowed for this style.';
      }
      if (inputType === 'alphanumeric' && !/^[a-zA-Z0-9]*$/.test(text)) {
        return 'Only letters and numbers are allowed for this style.';
      }
      
      if (minLen > 0 && textLen < minLen) {
        return `Minimum ${minLen} character${minLen > 1 ? 's' : ''} required.`;
      }
      if (maxLen < 999 && textLen > maxLen) {
        return `Maximum ${maxLen} character${maxLen > 1 ? 's' : ''} allowed.`;
      }
      
      return '';
    }

    function updateValidationMessage() {
      const style = getCurrentStyle();
      const text = state.currentText || '';
      
      const validationMsg = getValidationMessage(style, text);
      const isValid = validationMsg === '';
      
      const msgEl = document.querySelector('.cpc-validation-message');
      if (msgEl) {
        const textEl = msgEl.querySelector('.cpc-msg-text');
        if (textEl) textEl.textContent = validationMsg;
        msgEl.classList.toggle('visible', !isValid && text.length > 0);
      }
      
      updateAddToCartButton();
    }

    // ============================================================
    // UPDATE ADD TO CART BUTTON
    // ============================================================
    function updateAddToCartButton() {
      const isValid = isCurrentSelectionValid();
      const atcBtn = document.querySelector('.pinfo-add-to-cart');
      
      // Get the monogram properties container
      const propsContainer = document.querySelector('.customizer-properties');
      
      if (isValid && propsContainer) {
        // If valid and properties exist, enable the button
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('disabled');
        }
      } else {
        // If invalid, disable the button
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.setAttribute('disabled', 'disabled');
        }
      }
    }

    // ============================================================
    // WRITE PROPERTIES TO FORM
    // ============================================================
    function writePropertiesToForm() {
      const form = document.querySelector('.pinfo-form-wrapper form[action$="/cart/add"]');
      if (!form) { warn('Product form not found'); return; }

      let propsContainer = form.querySelector('.customizer-properties');
      if (!propsContainer) {
        propsContainer = document.createElement('div');
        propsContainer.className = 'customizer-properties';
        propsContainer.style.display = 'none';
        form.appendChild(propsContainer);
      }

      const style = getCurrentStyle();
      const placement = getCurrentPlacement();
      const colorObj = getCurrentColor();

      if (!style) return;

      propsContainer.innerHTML = '';

      const colorValue = colorObj?.name || '';

      let textValue = state.currentText || '';
      const rules = style.rules || {};
      if (rules.inputType === 'date' && textValue) {
        const digits = textValue.replace(/[^0-9]/g, '');
        if (digits.length > 0) {
          let formatted = digits;
          if (digits.length > 2) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2);
          }
          if (digits.length > 4) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
          }
          textValue = formatted;
        }
      }

      [
        { key: 'Category', val: state.selectedCategory || '' },
        { key: 'Style', val: style.name || '' },
        { key: 'Color', val: colorValue }, 
        { key: 'Placement', val: placement?.label || '' },
        { key: 'Text', val: textValue },
      ].forEach(({ key, val }) => {
        if (!val) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = val;
        propsContainer.appendChild(input);
      });

      updateAddToCartButton();
    }

    // ============================================================
    // RENDER FORM SECTIONS
    // ============================================================
    function getTodayDateString() {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const year = String(today.getFullYear()).slice(-2);
      return `${month}-${day}-${year}`;
    }

    function getFontPreviewContent(style) {
      const styleRules = style.rules || {};

      if (style.styleType === 'block_style') {
        if (style.swatchUrl) {
          return `<img src="${style.swatchUrl}" alt="${style.name}" />`;
        }
        return style.name;
      }

      const isSingleLetter = style.category === 'single letter';
      
      if (styleRules.inputType === 'date') {
        return getTodayDateString();
      }
      if (styleRules.inputType === 'numbers') {
        return isSingleLetter ? '1' : '123';
      }
      return isSingleLetter ? 'A' : 'ABC';
    }


    // ============================================================
    // FORM ROW SWIPERS (Style + Placement)
    // ============================================================
    var formSwipers = [];

    function destroyFormSwipers() {
      formSwipers.forEach(function(sw) {
        try { sw.destroy(true, true); } catch (e) { warn('Swiper destroy failed', e); }
      });
      formSwipers = [];
    }

    function initFormSwipers() {
      if (!formBody || typeof Swiper === 'undefined') return;

      formBody.querySelectorAll('.cpc-form-swiper').forEach(function(el) {
        var sw = new Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          watchOverflow: true,
          freeMode: {
            enabled: true,
            sticky: false,
            momentumBounce: false,
          },
          mousewheel: {
            enabled: true,
            sensitivity: 4,
          },
          scrollbar: {
            el: el.querySelector('.swiper-scrollbar'),
            draggable: true,
            hide: false
          },
          on: {
            lock: function() {
              this.mousewheel.disable();
            },
            unlock: function() {
              this.mousewheel.enable();
            },
            init: function() {
              if (this.isLocked) {
                this.mousewheel.disable();
              }
            }
          }
        });
        formSwipers.push(sw);
      });

      log('Form swipers initialized:', formSwipers.length);
    }


    function renderSections() {
      var categories = getCategories();
      if (!categories.length) {
        if (formBody) {
          formBody.innerHTML = '<div class="cpc-no-placements">No personalization options available.</div>';
        }
        return;
      }

      if (!formBody) return;

      destroyFormSwipers();
      formBody.innerHTML = '';
      var step = 1;

      formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Category</p><span class="cpc-section-current">' + (state.selectedCategory || '') + '</span></div><div class="cpc-category-grid">' + categories.map(function(cat) {
        return '<button class="cpc-category-btn ' + (state.selectedCategory === cat.category ? 'selected' : '') + '" data-category="' + cat.category + '">' + cat.category + '</button>';
      }).join('') + '</div></div>');

      var categoryToShow = state.selectedCategory || (categories.length > 0 ? categories[0].category : null);
      var styles = categoryToShow ? getStylesForCategory(categoryToShow) : [];

      if (styles.length) {
        var currentStyle = state.selectedStyle ? styles.find(function(s) { return s.styleId === state.selectedStyle; }) : null;
        var currentRules = currentStyle?.rules || {};

        var styleLabel = '';
        if (currentStyle) {
          if (currentStyle.styleType === 'block_style') {
            styleLabel = currentStyle.name;
          } else if (currentRules.inputType === 'date') {
            styleLabel = 'Date';
          } else if (currentRules.inputType === 'numbers') {
            styleLabel = 'Numbers';
          }
           else {
            styleLabel = 'Block Letters';
          }
        }

        formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header cpc-section-header--inline"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Style: <span class="cpc-style-current">' + (styleLabel || '') + '</span></p></div><div class="swiper cpc-form-swiper cpc-font-swiper"><div class="swiper-wrapper cpc-font-grid">' + styles.map(function(s) {
          var previewContent = getFontPreviewContent(s);
          var isSelected = state.selectedStyle === s.styleId;
          return '<button class="swiper-slide cpc-font-card ' + (isSelected ? 'selected' : '') + '" data-style-id="' + s.styleId + '"><div class="cpc-font-preview" style="' + (s.styleType === 'font_style' && s.fileUrl ? 'font-family:\'cpc-font-' + s.styleId + '\'' : '') + '">' + previewContent + '</div><div class="cpc-font-name">' + s.name + '</div></button>';
        }).join('') + '</div><div class="swiper-scrollbar"></div></div></div>');

        styles.forEach(function(s) { ensureFontFace(s); });

        var currentStyleObj = state.selectedStyle ? styles.find(function(s) { return s.styleId === state.selectedStyle; }) : null;
        var styleForColors = currentStyleObj || styles[0];
        if (styleForColors && styleForColors.colors?.length) {
          var colorObj = state.selectedColor ? styleForColors.colors.find(function(c) { return c.code === state.selectedColor; }) : null;
          var colorDisplayLabel = colorObj?.name || colorObj?.code || '';

          // --- UPDATED: Color swatches with Swiper ---
          formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Thread Color</p><span class="cpc-section-current cpc-color-current-label">' + colorDisplayLabel + '</span></div><div class="swiper cpc-form-swiper cpc-color-swiper"><div class="swiper-wrapper cpc-color-swatches">' + styleForColors.colors.map(function(clr) {
            return '<div class="swiper-slide cpc-color-swatch-wrapper"><button class="cpc-color-swatch ' + (state.selectedColor === clr.code ? 'selected' : '') + '" data-color="' + clr.code + '" data-color-name="' + (clr.name || '') + '" title="' + (clr.name || clr.code) + '"><span class="cpc-color-chip" style="background:' + clr.code + ';"></span><span class="cpc-color-name">' + (clr.name || clr.code) + '</span></button></div>';
          }).join('') + '</div><div class="swiper-scrollbar"></div></div></div>');
        }

        var styleForPlacements = currentStyleObj || styles[0];
        if (styleForPlacements && styleForPlacements.placements?.length) {
          var selPlacement = styleForPlacements.placements.find(function(p) { return p.placementId === state.selectedPlacement; });
          var placementLabel = selPlacement ? selPlacement.label : '';

          formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Placement</p><span class="cpc-section-current cpc-placement-current-label">' + placementLabel + '</span></div><div class="swiper cpc-form-swiper cpc-placement-swiper"><div class="swiper-wrapper cpc-placement-grid">' + styleForPlacements.placements.map(function(p) {
            var isSelected = state.selectedPlacement === p.placementId;
            var svgIcon = p.svgUrl ? '<img src="' + p.svgUrl + '" alt="' + p.label + '" class="cpc-placement-icon" />' : '';
            return '<button class="swiper-slide cpc-placement-btn ' + (isSelected ? 'selected' : '') + '" data-placement-id="' + p.placementId + '">' + svgIcon + '<span class="cpc-placement-label">' + p.label + '</span></button>';
          }).join('') + '</div><div class="swiper-scrollbar"></div></div></div>');
        }

        var styleForRules = currentStyleObj || styles[0];
        if (styleForRules) {
          var inputRules = styleForRules.rules || {};
          var inputType = inputRules.inputType || 'text';
          var isDate = inputType === 'date';
          var maxLen = isDate ? 6 : (inputRules.maxLength || 20);
          var minLen = isDate ? 6 : (inputRules.minLength || 0);

          var charLabel = '';
          if (isDate) charLabel = 'Format: DD-MM-YY';
          else if (minLen && minLen === maxLen) charLabel = 'Exactly ' + maxLen + ' Character' + (maxLen > 1 ? 's' : '');
          else if (minLen > 0) charLabel = 'Min. ' + minLen + ' Character' + (minLen > 1 ? 's' : '');
          else if (maxLen < 999) charLabel = 'Max. ' + maxLen + ' Character' + (maxLen > 1 ? 's' : '');

          var styleName = styleForRules?.name || '';
          var allowedHint = '';
          if (isDate) {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Enter 6 digits (DDMMYY). Displayed as DD-MM-YY.';
          } else if (inputType === 'letters') {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Letters only.';
          } else if (inputType === 'numbers') {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Numbers only.';
          } else if (inputType === 'alphanumeric') {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Letters and numbers only.';
          } else {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Text only.';
          }

          var rawText = state.currentText || '';
          var displayValue = rawText;
          if (isDate && rawText) {
            var digits = rawText.replace(/[^0-9]/g, '');
            if (digits.length > 0) {
              var formatted = digits;
              if (digits.length > 2) {
                formatted = digits.slice(0, 2) + '-' + digits.slice(2);
              }
              if (digits.length > 4) {
                formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
              }
              displayValue = formatted;
            }
          }
          var counterText = isDate ? rawText.length + '/6' : rawText.length + '/' + maxLen;

          formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> ' + (isDate ? 'Date' : 'Text') + '</p><span class="cpc-section-current">' + charLabel + '</span></div><div class="cpc-char-input-wrap"><input type="text" class="cpc-char-input" data-max="' + maxLen + '" data-min="' + minLen + '" data-input-type="' + inputType + '" maxlength="' + (isDate ? 8 : maxLen) + '" value="' + displayValue.replace(/"/g, '&quot;') + '" placeholder="' + (isDate ? 'DD-MM-YY' : 'Enter text') + '"><span class="cpc-char-counter">' + counterText + '</span></div><div class="cpc-validation-message"><span class="cpc-msg-text"></span><button class="cpc-clear-btn" data-clear-input>Clear</button></div>' + (minLen && !isDate ? '<p class="cpc-char-hint ' + (rawText.length > 0 && rawText.length < minLen ? 'cpc-error-msg' : '') + '">Minimum ' + minLen + ' character' + (minLen > 1 ? 's' : '') + ' required.</p>' : '') + (allowedHint ? '<p class="cpc-allowed-chars">' + allowedHint + '</p>' : '') + '</div>');
        }
      } else {
        formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Styles</p></div><div class="cpc-no-fonts-msg">No styles available for this category.</div></div>');
      }

      attachEventListeners();
      initFormSwipers();
    }


    function attachEventListeners() {
      if (!formBody) return;

      // Helper function to find matching color in new style
      function findMatchingColor(newStyle, oldColorCode) {
        if (!oldColorCode || !newStyle.colors || newStyle.colors.length === 0) {
          return null;
        }
        return newStyle.colors.find(function(c) {
          return c.code === oldColorCode;
        });
      }

      // Helper function to find matching placement in new style
      function findMatchingPlacement(newStyle, oldPlacementId) {
        if (!oldPlacementId || !newStyle.placements || newStyle.placements.length === 0) {
          return null;
        }
        return newStyle.placements.find(function(p) {
          return p.placementId === oldPlacementId;
        });
      }

      // Category buttons - CLEAR text when changing category
      formBody.querySelectorAll('.cpc-category-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          waitForReady(function() {
            injectMonogramSlidesOnFirstInteraction();
            
            var category = btn.dataset.category;
            state.selectedCategory = category;
            
            var styles = getStylesForCategory(category);
            if (styles.length > 0) {
              state.selectedStyle = styles[0].styleId;
              if (styles[0].colors && styles[0].colors.length > 0) {
                state.selectedColor = styles[0].colors[0].code;
              }
              if (styles[0].placements && styles[0].placements.length > 0) {
                state.selectedPlacement = styles[0].placements[0].placementId;
              }
            } else {
              state.selectedStyle = null;
              state.selectedColor = null;
              state.selectedPlacement = null;
            }
            
            state.currentText = '';
            renderSections();
            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      });

      // Style cards - PRESERVE color and placement if available
      formBody.querySelectorAll('.cpc-font-card').forEach(function(btn) {
        btn.addEventListener('click', function() {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              return;
            }
            
            injectMonogramSlidesOnFirstInteraction();
            
            var styleId = parseInt(btn.dataset.styleId, 10);
            var styles = getStylesForCategory(state.selectedCategory);
            var newStyle = styles.find(function(s) { return s.styleId === styleId; });
            
            if (newStyle) {
              var newRules = newStyle.rules || {};
              var currentText = state.currentText || '';
              var isCompatible = isInputCompatible(newRules, currentText);
              
              // Store old color and placement before changing
              var oldColorCode = state.selectedColor;
              var oldPlacementId = state.selectedPlacement;
              
              state.selectedStyle = styleId;
              
              // Try to preserve color
              var matchedColor = findMatchingColor(newStyle, oldColorCode);
              if (matchedColor) {
                state.selectedColor = matchedColor.code;
              } else if (newStyle.colors && newStyle.colors.length > 0) {
                state.selectedColor = newStyle.colors[0].code;
              } else {
                state.selectedColor = null;
              }
              
              // Try to preserve placement
              var matchedPlacement = findMatchingPlacement(newStyle, oldPlacementId);
              if (matchedPlacement) {
                state.selectedPlacement = matchedPlacement.placementId;
              } else if (newStyle.placements && newStyle.placements.length > 0) {
                state.selectedPlacement = newStyle.placements[0].placementId;
              } else {
                state.selectedPlacement = null;
              }
              
              // Clear text if incompatible
              if (!isCompatible) {
                state.currentText = '';
                var inputField = formBody.querySelector('.cpc-char-input');
                if (inputField) {
                  inputField.value = '';
                }
                var counter = formBody.querySelector('.cpc-char-counter');
                if (counter) {
                  var max = inputField ? inputField.dataset.max || 20 : 20;
                  counter.textContent = '0/' + max;
                }
                var msgEl = formBody.querySelector('.cpc-validation-message');
                if (msgEl) {
                  msgEl.classList.remove('visible');
                  var textEl = msgEl.querySelector('.cpc-msg-text');
                  if (textEl) textEl.textContent = '';
                }
              }
              
              renderSections();
              updateMonogramDisplay();
              activateMonogramPreview();
              writePropertiesToForm();
              updateValidationMessage();
            }
          });
        });
      });

      // Color swatches
      formBody.querySelectorAll('.cpc-color-swatch').forEach(function(sw) {
        sw.addEventListener('click', function() {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              return;
            }
            
            injectMonogramSlidesOnFirstInteraction();
            
            state.selectedColor = sw.dataset.color;
            formBody.querySelectorAll('.cpc-color-swatch').forEach(function(s) { s.classList.remove('selected'); });
            sw.classList.add('selected');
            var label = formBody.querySelector('.cpc-color-current-label');
            if (label) label.textContent = sw.dataset.colorName || "";
            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      });

      // Placement buttons
      formBody.querySelectorAll('.cpc-placement-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              return;
            }

            injectMonogramSlidesOnFirstInteraction();

            var placementId = parseInt(btn.dataset.placementId, 10);
            state.selectedPlacement = placementId;

            formBody.querySelectorAll('.cpc-placement-btn').forEach(function(b) { b.classList.remove('selected'); });
            btn.classList.add('selected');

            var placementLabelEl = formBody.querySelector('.cpc-placement-current-label');
            var btnLabelEl = btn.querySelector('.cpc-placement-label');
            if (placementLabelEl) placementLabelEl.textContent = btnLabelEl ? btnLabelEl.textContent : '';

            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      });

      // Text input
      var input = formBody.querySelector('.cpc-char-input');
      if (input) {
        input.addEventListener('input', function(e) {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              e.target.value = '';
              return;
            }
            
            injectMonogramSlidesOnFirstInteraction();
            
            var type = e.target.dataset.inputType || 'text';
            var max = parseInt(e.target.dataset.max, 10) || 20;
            var min = parseInt(e.target.dataset.min, 10) || 0;
            var isDate = type === 'date';

            if (isDate) {
              var digits = e.target.value.replace(/[^0-9]/g, '').slice(0, 6);
              var formatted = digits;
              if (digits.length > 2) {
                formatted = digits.slice(0, 2) + '-' + digits.slice(2);
              }
              if (digits.length > 4) {
                formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
              }
              e.target.value = formatted;
              state.currentText = digits;
              var counter = formBody.querySelector('.cpc-char-counter');
              if (counter) counter.textContent = digits.length + '/6';
            } else {
              var val = e.target.value;
              if (type === 'letters') val = val.replace(/[^a-zA-Z]/g, '');
              else if (type === 'numbers') val = val.replace(/[^0-9]/g, '');
              else if (type === 'alphanumeric') val = val.replace(/[^a-zA-Z0-9]/g, '');
              if (val.length > max) val = val.slice(0, max);
              e.target.value = val;
              state.currentText = val;
              var counter2 = formBody.querySelector('.cpc-char-counter');
              if (counter2) counter2.textContent = val.length + '/' + max;
              var hint = formBody.querySelector('.cpc-char-hint');
              if (hint) {
                hint.classList.toggle('cpc-error-msg', min > 0 && val.length > 0 && val.length < min);
              }
            }

            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      }

      // Clear button
      var clearBtn = formBody.querySelector('.cpc-clear-btn');
      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              return;
            }
            
            injectMonogramSlidesOnFirstInteraction();
            
            state.currentText = '';
            
            var inputField = formBody.querySelector('.cpc-char-input');
            if (inputField) {
              inputField.value = '';
            }
            
            var counter = formBody.querySelector('.cpc-char-counter');
            if (counter) {
              var max = inputField ? inputField.dataset.max || 20 : 20;
              counter.textContent = '0/' + max;
            }
            
            var hint = formBody.querySelector('.cpc-char-hint');
            if (hint) {
              hint.classList.remove('cpc-error-msg');
            }
            
            var msgEl = formBody.querySelector('.cpc-validation-message');
            if (msgEl) {
              msgEl.classList.remove('visible');
              var textEl = msgEl.querySelector('.cpc-msg-text');
              if (textEl) textEl.textContent = '';
            }
            
            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      }

      updateMonogramDisplay();
    }

    // ============================================================
    // COLOR SYNC
    // ============================================================
    function syncColorKey() {
      const checked = document.querySelector('input.pinfo-color-input:checked');
      if (!checked) return;
      const newKey = checked.value.toLowerCase().trim();
      if (newKey === state.colorKey || !CUSTOM_DATA[newKey]) return;

      log('Color variant changed to:', newKey);
      
      // Show loading state, auto-hide after color change timeout
      setLoadingState(true, CPC_CONFIG.LOADING_TIMEOUT_COLOR_CHANGE);
      
      state.colorKey = newKey;
      state.selectedCategory = null;
      state.selectedStyle = null;
      state.selectedColor = null;
      state.selectedPlacement = null;
      state.currentText = '';

      // Reset slide injection flag so they get re-injected
      slidesInjected = false;
      desktopSlideInserted = false;
      mobileSlideInserted = false;

      // Remove existing injected slides and thumbnails
      document.querySelectorAll('.cpc-monogram-slide-wrapper').forEach(el => el.remove());
      document.querySelectorAll('.cpc-monogram-thumb').forEach(el => el.remove());

      // Update preview image
      updatePreviewImage();

      // Re-render the form with no selections
      renderSections();
      writePropertiesToForm();
      updateValidationMessage();

      // No need for setTimeout here - loading auto-hides after CPC_CONFIG.LOADING_TIMEOUT_COLOR_CHANGE
      log('Color changed - slides removed, ready for re-injection');
    }

    // ============================================================
    // INITIALIZATION
    // ============================================================
    function init() {
      // Show loading state, auto-hide after configured timeout
      setLoadingState(true, CPC_CONFIG.LOADING_TIMEOUT);
      
      // Render the form with no selections
      renderSections();

      // Write initial properties (empty)
      writePropertiesToForm();
      updateValidationMessage();

      // Update preview image (show empty state)
      updatePreviewImage();

      // Listen for color changes
      document.addEventListener('variant:change', syncColorKey);
      document.addEventListener('input', function(e) {
        if (e.target?.classList?.contains('pinfo-color-input')) {
          syncColorKey();
        }
      });

      isInitialized = true;
      
      // No need for setTimeout here - loading auto-hides after CPC_CONFIG.LOADING_TIMEOUT
      log('Custom Placement initialized - waiting for user interaction');
    }


    // Wait for DOM to be ready and then initialize
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        // Wait a bit for the media gallery to be rendered
        setTimeout(init, 500);
      });
    } else {
      setTimeout(init, 500);
    }

    // Expose API for rechecking state
    window.__placementRecheck = function() {
      if (isInitialized) {
        syncColorKey();
        renderSections();
        writePropertiesToForm();
        updateValidationMessage();
      }
    };

    window.__customizerWriteProperties = function() {
      if (isInitialized) {
        writePropertiesToForm();
      }
    };

    // Also expose the instance for reattaching event listeners
    window.CustomPlacement = window.CustomPlacement || {};
    window.CustomPlacement.instance = {
      reattachEventListeners: function() {
        // Re-attach event listeners after DOM changes
        if (formBody) {
          attachEventListeners();
        }
      },
      recheckState: function() {
        if (isInitialized) {
          syncColorKey();
          renderSections();
          writePropertiesToForm();
          updateValidationMessage();
        }
      },
      writeProperties: function() {
        if (isInitialized) {
          writePropertiesToForm();
        }
      }
    };

    window.addEventListener('beforeunload', function() {
      removeTooltip();
      if (tooltipTimeout) {
        clearTimeout(tooltipTimeout);
        tooltipTimeout = null;
      }
    });

    log('Custom Placement inline script loaded');

  })();